export const devProtocol = window.location.protocol; export const devUrl = window.location.host;
